import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=2bcd1238&"
import script from "./shop-list.vue?vue&type=script&lang=js&"
export * from "./shop-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports